module.exports = __webpack_public_path__ + "static/media/ic_powerpoint.6d307cde.svg";